"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LeadComments = () => {
  const [allComments, setAllComments] = useState([]);
  const [groupedLeads, setGroupedLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
const [searchTerm, setSearchTerm] = useState("");

  // modal states
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [leadDetails, setLeadDetails] = useState(null);
  const [leadComments, setLeadComments] = useState([]);

  useEffect(() => {
    fetchAllComments();
  }, []);

  /* ================= FETCH ALL COMMENTS ================= */
  const fetchAllComments = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-all-leads-comment",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );

      const comments = res.data.data || [];
      setAllComments(comments);
      processComments(comments);
    } catch {
      toast.error("Failed to fetch lead comments");
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= GROUP & GET LATEST COMMENT ================= */
  const processComments = (comments) => {
    const map = {};

    comments.forEach((c) => {
      if (!map[c.lead_id]) {
        map[c.lead_id] = [];
      }
      map[c.lead_id].push(c);
    });

    const result = Object.keys(map).map((leadId) => {
      const sorted = map[leadId].sort(
        (a, b) => Number(b.comment_number) - Number(a.comment_number)
      );

      return {
        lead_id: leadId,
        latest: sorted[0],
        all: sorted,
      };
    });

    setGroupedLeads(result);
  };

  /* ================= VIEW ALL COMMENTS ================= */
  const openViewAll = async (leadId, comments) => {
    try {
      setSelectedLeadId(leadId);
      setLeadComments(comments);
      setIsViewOpen(true);

      const res = await axios.get(
        `https://logicx.premierlam.com/api/get-pixel-leads-data/${leadId}`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );

      setLeadDetails(res.data.data?.[0] || null);
    } catch {
      toast.error("Failed to load lead details");
    }
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
const filteredLeads = groupedLeads.filter((lead) =>
  [
    lead.lead_id,
    lead.latest?.lead_name,
    lead.latest?.lead_phone_number,
    lead.latest?.lead_comment,
    lead.latest?.added_by,
  ]
    .filter(Boolean) // remove undefined/null
    .join(" ")
    .toLowerCase()
    .includes(searchTerm.toLowerCase())
);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-2">
        <div className="max-w-7xl mx-auto">

          {/* HEADER */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">
              Lead Comments
            </h1>
            <p className="text-gray-500">
              Latest comment for each lead
            </p>
          </div>

          {/* TABLE */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex justify-between items-center mb-4">
  <input
    type="text"
    placeholder="Search lead comments..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="px-4 py-2 border rounded-lg w-64"
  />
</div>

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6">Loading...</div>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b text-gray-600 whitespace-nowrap">
                      <th className="py-3 px-4 text-left">Lead ID</th>
                      <th className="py-3 px-4 text-left">Name</th>
                      <th className="py-3 px-4 text-left">Phone</th>
                      <th className="py-3 px-4 text-left">Latest Comment</th>
                      <th className="py-3 px-4 text-left">Date</th>
                      <th className="py-3 px-4 text-left">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredLeads.map((l) => (
                      <tr key={l.lead_id} className="border-b hover:bg-gray-50">
                        <td className="py-3 px-4">{l.lead_id}</td>
                        <td className="py-3 px-4">
                          {l.latest.lead_name || "-"}
                        </td>
                        <td className="py-3 px-4">
                          {l.latest.lead_phone_number || "-"}
                        </td>
                        <td className="py-3 px-4">
                          {l.latest.lead_comment}
                        </td>
                        <td className="py-3 px-4 whitespace-nowrap">
                          {formatDate(l.latest.created_at)}
                        </td>
                        <td className="py-3 px-4">
                          <button
                            onClick={() => openViewAll(l.lead_id, l.all)}
                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded"
                          >
                            View All
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ================= VIEW ALL MODAL ================= */}
      {isViewOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
            <h2 className="text-lg font-semibold mb-3">
              Lead Details
            </h2>

            {leadDetails && (
              <div className="mb-4 text-sm grid grid-cols-2 gap-3">
                <div><b>Name:</b> {leadDetails.customer_name}</div>
                <div><b>Email:</b> {leadDetails.customer_email}</div>
                <div><b>Phone:</b> {leadDetails.customer_phone}</div>
                <div><b>Status:</b> {leadDetails.lead_status}</div>
              </div>
            )}

            <h3 className="text-sm font-semibold mb-2">All Comments</h3>

            <div className="space-y-3 max-h-80 overflow-y-auto">
              {leadComments.map((c) => (
                <div key={c.id} className="border rounded p-3">
                  <div className="text-xs text-gray-500 mb-1">
                    Comment #{c.comment_number} • {formatDate(c.created_at)}
                  </div>
                  <div className="text-sm">{c.lead_comment}</div>
                </div>
              ))}
            </div>

            <div className="flex justify-end pt-4">
              <button
                onClick={() => setIsViewOpen(false)}
                className="px-4 py-2 bg-gray-100 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadComments;
